import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { FormControlLabel, Radio } from "@material-ui/core";
import RadioGroupComp from "@material-ui/core/RadioGroup";
import themes from "../theme";

const styles = {
  root: {
    color: themes.palette.SELECTED,
    "&$checked": {
      color: themes.palette.SELECTED
    }
  },
  label: {
    marginRight: 45
  },
  checked: {}
};

export const SelectOneOfComp = ({
  className,
  sectionTitle,
  options,
  classes,
  selected,
  onChangeRadioGroup,
  disabled,
  ...rest
}) => {
  return (
    <div className={className}>
      <h2>{sectionTitle}</h2>
      <div className="radio-group">
        <RadioGroupComp
          name={`name_${Math.random()}`}
          value={selected}
          onChange={onChangeRadioGroup}
          {...rest}
        >
          {options.map(({ value, label }) => {
            return (
              <FormControlLabel
                className={classes.label}
                key={value}
                value={value}
                control={
                  <Radio // eslint-disable-line react/jsx-wrap-multilines
                    classes={{
                      root: classes.root,
                      checked: classes.checked
                    }}
                  />
                }
                label={label}
                checked={+selected === +value}
                disabled={disabled}
              />
            );
          })}
        </RadioGroupComp>
      </div>
    </div>
  );
};

SelectOneOfComp.propTypes = {
  className: PropTypes.string,
  sectionTitle: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({})),
  classes: PropTypes.shape({}),
  selected: PropTypes.string,
  onChangeRadioGroup: PropTypes.func,
  disabled: PropTypes.bool
};

SelectOneOfComp.defaultProps = {
  className: "",
  sectionTitle: "",
  options: [],
  classes: {},
  selected: "",
  onChangeRadioGroup: () => {},
  disabled: false
};

export const RadioGroup = styled(withStyles(styles)(SelectOneOfComp))`
  display: block;
  h2 {
    font-family: ${({ theme }) => theme.fontFamily.BOLD};
    font-size: ${({ theme }) => theme.fontSize.MEDIUM2};
    font-weight: normal;
    padding-bottom: 10px;
    margin: 0;
  }
  .radio-group {
    > div {
      flex-direction: row;
    }
  }
`;
